import React from 'react';
import { string, oneOf } from 'prop-types';
import Menu from "semantic-ui-react/dist/es/collections/Menu/Menu.js";
import Image from "semantic-ui-react/dist/es/elements/Image/Image.js";
import classnames from 'classnames';
import { Heading } from "../../typography/Heading";
import { Paragraph } from "../../typography/Paragraph";
import { FlexContainer } from "../../layout/FlexContainer";
import { testidFactory } from "../../../utils/testid";
import { TEST_ID_PREFIX, LOGO_CLASS } from "./constants";
var testid = testidFactory(TEST_ID_PREFIX);
export var Component = function Component(_ref) {
  var logoHref = _ref.logoHref,
      logoSize = _ref.logoSize,
      logoSizes = _ref.logoSizes,
      logoSrc = _ref.logoSrc,
      logoSrcSet = _ref.logoSrcSet,
      logoSubText = _ref.logoSubText,
      logoSubTextAlignment = _ref.logoSubTextAlignment,
      logoText = _ref.logoText;
  return React.createElement(Menu.Item, {
    className: classnames(LOGO_CLASS, {
      'has-sub-text': !!logoSubText
    }),
    "data-testid": testid(),
    href: logoHref,
    link: true
  }, React.createElement(FlexContainer, {
    flexDirection: "column",
    justifyContent: "center"
  }, logoSrc ? React.createElement(Image, {
    alt: logoText,
    className: "".concat(logoSize, "-logo"),
    "data-testid": testid('image'),
    sizes: logoSizes,
    src: logoSrc,
    srcSet: logoSrcSet
  }) : React.createElement(Heading, {
    className: "header-title",
    size: "small"
  }, logoText), logoSubText && React.createElement(Paragraph, {
    className: "subtext-aligned ".concat(logoSubTextAlignment),
    "data-testid": testid('subtext'),
    size: "tiny",
    title: logoSubText
  }, logoSubText)));
};
Component.displayName = 'Logo';
Component.defaultProps = {
  logoHref: null,
  logoSize: 'medium',
  logoSizes: undefined,
  logoSrc: undefined,
  logoSrcSet: undefined,
  logoSubText: '',
  logoSubTextAlignment: 'left',
  logoText: ''
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  logoHref: string,
  logoSize: oneOf(['medium', 'large', 'huge']),
  logoSizes: string,
  logoSrc: string,
  logoSrcSet: string,
  logoSubText: string,
  logoSubTextAlignment: oneOf(['left', 'center', 'right']),
  logoText: string
} : {};